(() => {
  function init() {
    const uiSpanish = document.documentElement.lang.toLowerCase().startsWith("es");
    const uiMap = {"Expo product inquiries": "Consultas sobre productos de la expo", "Which product are you interested in? (required)": "¿Qué producto te interesa? (obligatorio)", "Select a product": "Elige un producto", "Multiple products": "Varios productos", "Contact the right RZ team": "Contacta con el equipo adecuado de RZ", "Choose support type": "Elige el tipo de ayuda", "Product support": "Ayuda con un producto", "Order support": "Ayuda con un pedido", "Delivery country (optional)": "País de entrega (opcional)", "Country (required)": "País (obligatorio)", "What happened with your order? (required)": "¿Qué pasó con tu pedido? (obligatorio)", "How can we help? (required)": "¿En qué podemos ayudarte? (obligatorio)", "Tell us what has gone wrong, when you ordered, and any tracking update you have. Do not include payment or other sensitive personal information.": "Cuéntanos qué salió mal, cuándo hiciste el pedido y qué información de seguimiento tienes. No incluyas datos de pago ni otra información personal sensible.", "Describe the product problem and what you need help with. Do not include payment, medical, or other sensitive personal information.": "Describe el problema del producto y la ayuda que necesitas. No incluyas datos de pago, médicos ni otra información personal sensible.", "You selected customer service. Any details you entered have been carried over. Complete the support form below to send your request.": "Elegiste atención al cliente. Hemos conservado los datos que introdujiste. Completa el formulario de ayuda para enviar tu consulta.", "Get product or order support": "Obtén ayuda con un producto o pedido", "Loading the secure RZ form. Please wait a moment.": "Cargando el formulario seguro de RZ. Espera un momento.", "The form is taking longer than expected. You can try again or contact RZ Sales by email.": "El formulario está tardando más de lo previsto. Vuelve a intentarlo o escribe al equipo de ventas de RZ.", "Thank you. Your request has been sent to RZ. No order has been placed.": "Gracias. Hemos enviado tu consulta a RZ. No se ha realizado ningún pedido.", "Send my request": "Enviar mi consulta", "Talk to RZ Sales": "Habla con el equipo de ventas de RZ", "Have a question about products or purchasing for your team? Tell us what you need, and the RZ sales team will follow up.": "¿Tienes preguntas sobre productos o compras para tu equipo? Cuéntanos qué necesitas y el equipo de ventas de RZ se pondrá en contacto contigo.", "RZ will review your request and follow up with product information and next steps. Submitting this form does not place an order or guarantee a sample.": "RZ revisará tu consulta y responderá con información del producto y los próximos pasos. Enviar este formulario no realiza un pedido ni garantiza una muestra.", "RZ will review your request and follow up with product information and next steps. Submitting this form does not place an order.": "RZ revisará tu consulta y responderá con información del producto y los próximos pasos. Enviar este formulario no realiza un pedido.", "Talk to us about RZ AIRflow": "Pregúntanos sobre RZ AIRflow", "Ask about RZM3": "Pregúntanos sobre RZM3", "Ask about RZ Pro": "Pregúntanos sobre RZ Pro", "Ask about RZ Pro FFP2": "Pregúntanos sobre RZ Pro FFP2", "Ask about RZ Pro FFP3": "Pregúntanos sobre RZ Pro FFP3", "Ask about upcoming RZ Pro 99": "Pregúntanos sobre el próximo RZ Pro 99", "Ask about filters and parts": "Pregúntanos sobre filtros y repuestos", "Ask about masks and respirators": "Pregúntanos sobre máscaras y respiradores", "Ask about RZ accessories": "Pregúntanos sobre accesorios RZ", "Discuss ongoing filter supply": "Hablemos del suministro continuo de filtros", "Request product documentation": "Solicita documentación del producto", "Ask about fit and product requirements": "Pregúntanos sobre ajuste y requisitos del producto", "Get help choosing your RZ": "Obtén ayuda para elegir tu RZ", "Ask about RZ for agriculture": "Pregúntanos sobre RZ para agricultura", "Ask about RZ for manufacturing": "Pregúntanos sobre RZ para manufactura", "Ask about RZ for powersports": "Pregúntanos sobre RZ para deportes motorizados", "Ask about RZ for woodworking": "Pregúntanos sobre RZ para carpintería", "Discuss products for your industry": "Hablemos de productos para tu sector", "Get help with products and purchasing": "Obtén ayuda con productos y compras"};
    Object.assign(uiMap, {
      'Ask about the RZ range': 'Consulta sobre la gama de productos RZ',
      'Choose the product that interests you and tell us what you need. RZ will follow up with information for your product and market. RZ Pro 99 requests are for certification status and commercial availability notifications only.': 'Elige el producto que te interesa y cuéntanos qué necesitas. RZ responderá con información sobre el producto y su disponibilidad en tu mercado. Las consultas sobre RZ Pro 99 son solo para conocer el estado de su certificación y recibir avisos de disponibilidad comercial.',
      'RZ will confirm product availability, market requirements and next steps with you. Any order or sample arrangement is agreed separately.': 'RZ confirmará contigo la disponibilidad del producto, los requisitos de tu mercado y los próximos pasos. Los pedidos o muestras se acuerdan por separado.',
      'Fire department sales inquiry': 'Consulta para departamentos de bomberos',
      'Tell RZ about your department and what would help next.': 'Cuéntanos sobre tu departamento y qué información necesitas para dar el siguiente paso.',
      'RZ will review your request and follow up with the appropriate fire program information.': 'RZ revisará tu consulta y responderá con información pertinente para tu departamento.',
      'Dealer or distributor inquiry': 'Consulta para distribuidores',
      'Start with your contact details. RZ will follow up to discuss whether you want to become a dealer or distributor, your market, and your product interests.': 'Déjanos tus datos de contacto. RZ se comunicará contigo para hablar sobre la distribución, tu mercado y los productos de interés.',
      'RZ will review your request and follow up about the dealer or distribution opportunity.': 'RZ revisará tu consulta y responderá sobre las oportunidades de distribución.',
      'RZM3 (uncertified)': 'RZM3 (sin certificación)'
    });
    const ui = text => uiSpanish ? (uiMap[text] || text) : text;
    const picker = document.querySelector('#rz-inquiry-route');
    const inline = document.querySelector('#rz-inquiry');
    const params = new URLSearchParams(location.search);
    if(inline){
      params.set('route', inline.dataset.rzInlineRoute);
      if (!params.has('intent')) params.set('intent', inline.dataset.rzInlineIntent);
      if(inline.dataset.rzInlineRoute === 'expo') params.set('source','nsc-expo-2026');
    }
    const pageProfiles = {
  "rz-rz-airflow": {
    "title": "Talk to us about RZ AIRflow",
    "intro": "Have questions about compatibility, replacement filters, or purchasing for your property? Tell us about your building and existing equipment, and we will help you identify the next step. If known, include your PTAC model and approximate room count in your message; these details are optional.",
    "product": "RZ AIRflow"
  },
  "rz-collections-airflow": {
    "title": "Talk to us about RZ AIRflow",
    "intro": "Have questions about compatibility, replacement filters, or purchasing for your property? Tell us about your building and existing equipment, and we will help you identify the next step. If known, include your PTAC model and approximate room count in your message; these details are optional.",
    "product": "RZ AIRflow"
  },
  "rz-rzm3": {
    "title": "Ask about RZM3",
    "intro": "Tell us what you would like to know about RZM3 masks, sizing, filters, or purchasing.",
    "product": "RZM3"
  },
  "rz-products-rzm3-mask": {
    "title": "Ask about RZM3",
    "intro": "Tell us what you would like to know about RZM3 masks, sizing, filters, or purchasing.",
    "product": "RZM3"
  },
  "rz-rz-pro": {
    "title": "Ask about RZ Pro",
    "intro": "Tell us about your intended use and market, or request product documentation and purchasing information.",
    "product": "RZ Pro"
  },
  "rz-products-rz-pro-ffp2": {
    "title": "Ask about RZ Pro FFP2",
    "intro": "Ask about this product configuration, documentation, availability, and current approval status for your market.",
    "product": "RZ Pro"
  },
  "rz-products-rz-pro-ffp3": {
    "title": "Ask about RZ Pro FFP3",
    "intro": "Ask about this product configuration, documentation, availability, and current approval status for your market.",
    "product": "RZ Pro"
  },
  "rz-products-rz-pro-n99": {
    "title": "Ask about upcoming RZ Pro 99",
    "intro": "Ask about this product configuration, documentation, availability, and current approval status for your market.",
    "product": "RZ Pro"
  },
  "rz-collections-filters-and-parts": {
    "title": "Ask about filters and parts",
    "intro": "Tell us the model on your mask and which replacement filters or parts you need help finding.",
    "product": ""
  },
  "rz-collections-masks": {
    "title": "Ask about masks and respirators",
    "intro": "Tell us about your intended use and market so the team can help you compare product options.",
    "product": ""
  },
  "rz-collections-accessories": {
    "title": "Ask about RZ accessories",
    "intro": "Tell us which accessory you are considering and any compatibility or purchasing questions.",
    "product": ""
  },
  "rz-enterprise-replenishment": {
    "title": "Discuss ongoing filter supply",
    "intro": "Tell us about your equipment, team size, and replacement supply needs.",
    "product": "RZ Pro"
  },
  "rz-evidence": {
    "title": "Request product documentation",
    "intro": "Tell us which product, test report, certification, or approval status you want to understand.",
    "product": ""
  },
  "rz-respirator-fit-matters": {
    "title": "Ask about fit and product requirements",
    "intro": "Tell us about the product and workplace requirements you are reviewing. Consult qualified safety personnel for workplace fit and protection decisions.",
    "product": ""
  },
  "rz-find-your-rz": {
    "title": "Get help choosing your RZ",
    "intro": "Tell us about your intended use, product questions, and what you need help comparing.",
    "product": ""
  },
  "rz-learn": {
    "title": "Get help choosing your RZ",
    "intro": "Tell us about your intended use, product questions, and what you need help comparing.",
    "product": ""
  },
  "rz-industries-agriculture": {
    "title": "Ask about RZ for agriculture",
    "intro": "Tell us about your agriculture tasks, intended use, and product questions so the team can discuss appropriate information and next steps.",
    "product": ""
  },
  "rz-industries-manufacturing": {
    "title": "Ask about RZ for manufacturing",
    "intro": "Tell us about your manufacturing tasks, intended use, and product questions so the team can discuss appropriate information and next steps.",
    "product": ""
  },
  "rz-industries-powersports": {
    "title": "Ask about RZ for powersports",
    "intro": "Tell us about your powersports tasks, intended use, and product questions so the team can discuss appropriate information and next steps.",
    "product": ""
  },
  "rz-industries-woodworking": {
    "title": "Ask about RZ for woodworking",
    "intro": "Tell us about your woodworking tasks, intended use, and product questions so the team can discuss appropriate information and next steps.",
    "product": ""
  },
  "rz-industries": {
    "title": "Discuss products for your industry",
    "intro": "Tell us about your industry, tasks, and product requirements.",
    "product": ""
  },
  "rz-shop": {
    "title": "Get help with products and purchasing",
    "intro": "Tell us which products you are considering and what you need help choosing or purchasing.",
    "product": ""
  }
};
    const pageProfile = inline ? pageProfiles[params.get('view')] : null;
    const pageTopic = inline ? (pageProfile?.title || document.querySelector('h1')?.textContent.trim().replace(/\s+/g, ' ')) : '';
    if (inline && !params.has('topic') && pageTopic) params.set('topic', pageTopic);
    let readyFields = null;
    let applyContext = null;
    let autoMessage = null;
    const savedContact = {};
    if (!picker) return;
    const service = document.querySelector('[data-rz-service-panel]');
    const sales = document.querySelector('[data-rz-sales-panel]');
    const target = document.querySelector('#rz-sales-embed');
    const productRow = document.createElement('div');
    productRow.className = 'form-wide';
    productRow.hidden = true;
    const productLabel = document.createElement('label');
    productLabel.htmlFor = 'rz-expo-product';
    productLabel.textContent = ui('Which product are you interested in? (required)');
    const productPicker = document.createElement('select');
    productPicker.id = 'rz-expo-product';
    productPicker.required = true;
    const expoTeamOption = picker.querySelector('option[value="expo"]');
    if(expoTeamOption)expoTeamOption.textContent=ui('Expo product inquiries');
    productPicker.style.cssText = 'width:100%;min-height:52px;margin:8px 0 24px;';
    productPicker.append(new Option(ui('Select a product'), ''),new Option('RZ Pro 99','RZ Pro N99'),new Option('RZ Pro FFP2','RZ Pro FFP2'),new Option('RZ Pro FFP3','RZ Pro FFP3'),new Option('RZM3 (uncertified)','RZM3'),new Option(ui('Multiple products'),'Multiple products'));
    productRow.append(productLabel,productPicker);
    picker.closest('.form-wide').after(productRow);
    productPicker.addEventListener('change',()=>{params.set('product_interest',productPicker.value);if(applyContext)applyContext();});
    const status = document.querySelector('[data-rz-sales-loading]');
    const retry = document.querySelector('[data-rz-sales-retry]');
    const fallback = document.querySelector('[data-rz-sales-fallback]');
    let renderTimer;
    const heading = document.querySelector('[data-rz-sales-heading]');
    const intro = document.querySelector('[data-rz-sales-intro]');
    const context = document.querySelector('[data-rz-sales-context]');
    const disclaimer = document.querySelector('[data-rz-sales-disclaimer]');
    const request = document.querySelector('#rz-contact-request');
    const form = document.querySelector('#RzContactForm');
    const pageHeading = document.querySelector('#details > .section-heading h2');
    if (pageHeading && !inline) pageHeading.textContent = ui('Contact the right RZ team');
    const sampleNote = document.querySelector('[data-rz-sample-note]');
    if (sampleNote) sampleNote.hidden = true;
    // Existing RZ embeds, copied from the fire and dealer page templates.
    const forms = {
      expo: {
        id: 'f3af71a1-0e3a-4bcd-86e4-8e214834b617',
        title: 'Ask about the RZ range',
        intro: 'Choose the product that interests you and tell us what you need. RZ will follow up with information for your product and market. RZ Pro 99 requests are for certification status and commercial availability notifications only.',
        disclaimer: 'RZ will confirm product availability, market requirements and next steps with you. Any order or sample arrangement is agreed separately.'
      },
      sales: {
        id: 'a059c1ca-891b-4a93-a836-d996b56e1885',
        title: 'Talk to RZ Sales',
        intro: 'Have a question about products or purchasing for your team? Tell us what you need, and the RZ sales team will follow up.',
        disclaimer: 'RZ will review your request and follow up with product information and next steps. Submitting this form does not place an order or guarantee a sample.'
      },
      fire: { id: '8171f297-df37-4fa2-802b-9d89d88ce015', title: 'Fire department sales inquiry', intro: 'Tell RZ about your department and what would help next.', disclaimer: 'RZ will review your request and follow up with the appropriate fire program information.' },
      dealer: { id: '54cb7ea8-2158-4413-8b5a-c69478bd97a7', title: 'Dealer or distributor inquiry', intro: 'Start with your contact details. RZ will follow up to discuss whether you want to become a dealer or distributor, your market, and your product interests.', disclaimer: 'RZ will review your request and follow up about the dealer or distribution opportunity.' }
    };
    if (request) {
      request.replaceChildren(new Option(ui('Choose support type'), ''), new Option(ui('Product support'), 'Product support'), new Option(ui('Order support'), 'Order support'));
      request.value = params.get('support_type') === 'order' ? 'Order support' : '';
      const updateSupport = () => {
        const order = request.value === 'Order support';
        form.querySelectorAll('[data-rz-order-support]').forEach(row => {row.hidden = !order; row.querySelectorAll('input').forEach(field => field.disabled = !order);});
        form.querySelectorAll('[data-rz-product-support]').forEach(row => {row.hidden = order; row.querySelectorAll('input,select').forEach(field => field.disabled = order);});
        const country = form.querySelector('#rz-contact-country');
        country.required = !order;
        form.querySelector('label[for="rz-contact-country"]').textContent = order ? ui('Delivery country (optional)') : ui('Country (required)');
        form.querySelector('label[for="rz-contact-body"]').textContent = order ? ui('What happened with your order? (required)') : ui('How can we help? (required)');
        form.querySelector('#rz-contact-body').placeholder = order ? ui('Tell us what has gone wrong, when you ordered, and any tracking update you have. Do not include payment or other sensitive personal information.') : ui('Describe the product problem and what you need help with. Do not include payment, medical, or other sensitive personal information.');
        const ptac = form.querySelector('[data-rz-ptac]');
        if(ptac){ptac.hidden=order || form.querySelector('#rz-contact-interest').value !== 'RZ AIRflow';ptac.querySelector('input').disabled=ptac.hidden;}
      };
      request.addEventListener('change', updateSupport);
      form.querySelector('#rz-contact-interest')?.addEventListener('change', updateSupport);
      updateSupport();
    }
    // Customer service is a support route even when chosen inside a sales embed.
    function routeCustomerService(sourceForm, event) {
      if (sourceForm.querySelector('[name="rz_inquiry_type"]')?.value !== 'Customer service' || !form || !service) return false;
      event?.preventDefault();
      event?.stopImmediatePropagation();
      const read = name => sourceForm.querySelector('[name="' + name + '"]')?.value.trim() || '';
      const values = {
        'rz-contact-name': [read('firstname'), read('lastname')].filter(Boolean).join(' '),
        'rz-contact-email': read('email'),
        'rz-contact-phone': read('phone'),
        'rz-contact-company': read('company'),
        'rz-contact-body': sourceForm.querySelector('textarea')?.value || '',
        'rz-contact-interest': read('rz_product_interest').replace(/^RZ Pro N99$/, 'Upcoming RZ Pro 99')
      };
      // Read first: show() removes the embedded sales form. Country is not copied
      // because the sales field asks where the product is used, not its country.
      picker.value = 'support';
      show();
      for (const [id, value] of Object.entries(values)) {
        const field = form.querySelector('#' + id);
        if (!field || !value) continue;
        if (field.tagName === 'SELECT' && !Array.from(field.options).some(option => option.value === value)) continue;
        field.value = id === 'rz-contact-body' && field.value.trim() && field.value.trim() !== value.trim()
          ? field.value.trim() + '\n\n' + value.trim() : value;
        field.dispatchEvent(new Event('input', {bubbles:true}));
        field.dispatchEvent(new Event('change', {bubbles:true}));
      }
      if (request && !request.value) {
        request.value = 'Product support';
        request.dispatchEvent(new Event('change', {bubbles:true}));
      }
      let notice = service.querySelector('#rz-support-handoff');
      if (!notice) {
        notice = document.createElement('p');
        notice.id = 'rz-support-handoff';
        notice.setAttribute('role', 'status');
        notice.setAttribute('tabindex', '-1');
        service.prepend(notice);
      }
      notice.textContent = ui('You selected customer service. Any details you entered have been carried over. Complete the support form below to send your request.');
      notice.focus();
      return true;
    }
    let loader;
    function loadHubSpot() {
      if (window.hbspt?.forms) return Promise.resolve();
      if (!loader) loader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timer = setTimeout(() => { script.remove(); reject(new Error('Form script timed out')); }, 15000);
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.onload = () => {clearTimeout(timer); window.hbspt?.forms ? resolve() : reject(new Error('Form service unavailable'));};
        script.onerror = () => {clearTimeout(timer); script.remove(); reject(new Error('Form script unavailable'));};
        document.head.appendChild(script);
      }).catch(error => {loader = null; throw error;});
      return loader;
    }
    let revision = 0;
    let started = false;
    async function show() {
      started = true;
      const current = ++revision;
      clearTimeout(renderTimer);
      retry.hidden = true;
      fallback.hidden = true;
      const route = picker.value;
      productRow.hidden = true;
      productPicker.disabled = route !== 'expo';
      for (const field of readyFields?.querySelectorAll('input[name]') || []) {
        if (['firstname','lastname','email','phone','company'].includes(field.name) && field.value) savedContact[field.name] = field.value;
      }
      readyFields = null;
      applyContext = null;
      service.hidden = route !== 'support';
      sales.hidden = !forms[route];
      document.querySelector('#rz-expo-validation')?.remove();
      document.querySelector('#rz-expo-submit')?.remove();
      target.replaceChildren();
      const selected = forms[route] ? {...forms[route]} : null;
      if (selected && route === 'sales' && pageProfile) Object.assign(selected, {title: pageProfile.title, intro: pageProfile.intro, disclaimer: 'RZ will review your request and follow up with product information and next steps. Submitting this form does not place an order.'});
      if(inline) inline.querySelector('#rz-inquiry-title').textContent = ui(selected?.title || 'Get product or order support');
      if (!selected) return;
      heading.textContent = ui(selected.title);
      intro.textContent = ui(selected.intro);
      disclaimer.textContent = ui(selected.disclaimer);

      // Campaign attribution does not change the selected team or product form.
      const spanishFormIds = {
        sales: 'e3300d99-ef9c-48f2-af8d-c38b98356f04',
        expo: '5f5de9e5-237c-4abc-9de6-312bd089545c',
        fire: '2508f6ee-2eca-44c1-a4c0-4c7d0609b689',
        dealer: '146e6e88-f5ba-4161-9cab-2e05b0ce5ebf'
      };
      const formId = uiSpanish ? (spanishFormIds[route] || selected.id) : selected.id;
      const labels = {
        personal: 'Personal use', work: 'A workplace or team', room: 'A room with a PTAC unit',
        particles: 'Dust or particles', gas: 'Gas, vapor, chemical spray, or smoke', emergency: 'Emergency or oxygen deficient conditions', unknown: 'I do not know',
        'us-required': 'United States workplace requiring an approved respirator', us: 'United States, other use', eu: 'European market', other: 'Another market or not sure',
        compare: 'Understand the product options', documents: 'Find technical documents', help: 'Ask RZ for guidance'
      };
      const labelsEs = {
        personal: 'Uso personal', work: 'Un lugar de trabajo o equipo', room: 'Una habitación con unidad PTAC',
        particles: 'Polvo o partículas', gas: 'Gases, vapores, aerosoles químicos o humo', emergency: 'Emergencias o ambientes con poco oxígeno', unknown: 'No lo sé',
        'us-required': 'Trabajo en EE. UU. que requiere un respirador aprobado', us: 'Otro uso en Estados Unidos', eu: 'Mercado europeo', other: 'Otro mercado o no estoy seguro',
        compare: 'Conocer las opciones de productos', documents: 'Encontrar documentos técnicos', help: 'Pedir orientación a RZ'
      };
      const answers = ['purpose','air','market','need'].map(key => (uiSpanish ? labelsEs : labels)[params.get(key)]).filter(Boolean);
      const topic = (params.get('topic') || '').slice(0,200);
      context.hidden = answers.length === 0 && !topic;
      context.textContent = [topic ? `${uiSpanish ? 'Tu consulta' : 'Your request'}: ${topic}` : '', answers.length ? `${uiSpanish ? 'Tus respuestas' : 'Your answers are carrying forward'}: ${answers.join(' · ')}` : ''].filter(Boolean).join('. ');
      status.textContent = ui('Loading the secure RZ form. Please wait a moment.');
      const stalled = () => {
        if(current !== revision) return;
        status.textContent = ui('The form is taking longer than expected. You can try again or contact RZ Sales by email.');
        retry.hidden = false; fallback.hidden = false;
      };
      renderTimer = setTimeout(stalled, 15000);
      try {
        await loadHubSpot();
        if (current !== revision) return;
        // HubSpot's new-editor forms render in an iframe and do not fire the
        // legacy onFormReady callback. Clear the loading state when that frame
        // actually loads; legacy forms continue to use onFormReady below.
        const frameObserver = new MutationObserver(() => {
          const frame = target.querySelector('.hs-form-frame iframe');
          if (!frame) return;
          frameObserver.disconnect();
          frame.addEventListener('load', () => {
            if (current !== revision) return;
            clearTimeout(renderTimer);
            status.textContent = '';
            retry.hidden = true;
            fallback.hidden = true;
          }, {once: true});
        });
        frameObserver.observe(target, {childList: true, subtree: true});
        window.hbspt.forms.create({
          region: 'na1', portalId: '7871913', formId, target: '#rz-sales-embed',
          onFormSubmitted: () => {
            document.querySelector('#rz-expo-submit')?.remove();
            status.textContent = ui('Thank you. Your request has been sent to RZ. No order has been placed.');
          },
          onFormReady: readyForm => {
            if (current !== revision) return;
            clearTimeout(renderTimer); status.textContent = ''; retry.hidden = true; fallback.hidden = true;
            const form = readyForm?.querySelector ? readyForm : readyForm?.[0];
            if (!form?.querySelector) return;
            readyFields = form;
            if (route === 'expo') {
              const errorBox = document.createElement('div');
              errorBox.setAttribute('role', 'alert');
              errorBox.setAttribute('tabindex', '-1');
              errorBox.style.cssText = 'background:#fff;color:#102f3b;border:3px solid #00aed3;padding:16px;margin:0 0 20px;font-weight:700;';
              errorBox.hidden = true;
              errorBox.id = 'rz-expo-validation';
              target.before(errorBox);
              const validateExpo = event => {
                const missing = [];
                const fieldLabels = uiSpanish
                  ? {email:'Correo',firstname:'Nombre',lastname:'Apellidos',country:'¿Dónde se utilizará el producto?',rz_inquiry_type:'¿Qué necesitas de RZ?',rz_product_interest:'¿Qué producto te interesa?'}
                  : {email:'Email',firstname:'First name',lastname:'Last name',country:'Where will the product be used?',rz_inquiry_type:'What would you like from RZ?',rz_product_interest:'Which product are you interested in?'};
                for (const [name,label] of Object.entries(fieldLabels)) {
                  const field = form.querySelector(`[name="${name}"]`);
                  if (field && !field.disabled && !field.value.trim()) missing.push(label);
                }
                const email = form.querySelector('[name="email"]');
                const badEmail = email?.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
                if (!missing.length && !badEmail) {errorBox.hidden=true;return;}
                event.preventDefault();
                event.stopImmediatePropagation();
                errorBox.textContent = [missing.length ? (uiSpanish ? 'Completa estos campos: ' : 'Please complete: ')+missing.join(', ')+'.' : '',badEmail ? (uiSpanish ? 'Ingresa un correo válido, como nombre@ejemplo.com.' : 'Enter a valid email address, such as name@example.com.') : ''].filter(Boolean).join(' ');
                errorBox.hidden = false;
                errorBox.focus();
                errorBox.scrollIntoView({block:'center'});
              };
              form.addEventListener('click', event => {
                if(event.target.closest('input[type="submit"],button[type="submit"]')) validateExpo(event);
              }, true);
              form.addEventListener('submit', validateExpo, true);
              const submitButton = document.createElement('button');
              submitButton.id = 'rz-expo-submit';
              submitButton.type = 'button';
              submitButton.className = 'button primary';
              submitButton.textContent = ui('Send my request');
              submitButton.addEventListener('click',()=>form.requestSubmit());
              target.after(submitButton);
              const embeddedSubmit = form.querySelector('input[type="submit"],button[type="submit"]');
              if(embeddedSubmit) embeddedSubmit.hidden = true;
            }

            const requestField = form.querySelector('[name="rz_inquiry_type"]');
            const requestOptions = requestField ? Array.from(requestField.options).map(o=>[o.text,o.value]) : [];
            let n99Mode = false;
            applyContext = () => {
      context.hidden = answers.length === 0 && !params.get('topic');
      context.textContent = [params.get('topic') ? `${uiSpanish ? 'Tu consulta' : 'Your request'}: ${params.get('topic')}` : '', answers.length ? `${uiSpanish ? 'Tus respuestas' : 'Your answers are carrying forward'}: ${answers.join(' · ')}` : ''].filter(Boolean).join('. ');
            const topic = (params.get('topic') || '').slice(0,200);
            status.textContent = '';
            const set = (name, value) => {
              const field = form.querySelector(`[name="${name}"]`);
              if (!field) return;
              if (!value && !name.startsWith('rz_questionnaire_') && name !== 'rz_product_interest') return;
              value = value || '';
              if (field.tagName === 'SELECT' && !Array.from(field.options).some(option => option.value === value)) return;
              const realm = field.ownerDocument.defaultView;
              const prototype = field.tagName === 'SELECT' ? realm.HTMLSelectElement.prototype : field.tagName === 'TEXTAREA' ? realm.HTMLTextAreaElement.prototype : realm.HTMLInputElement.prototype;
              Object.getOwnPropertyDescriptor(prototype, 'value').set.call(field, value);
              field.dispatchEvent(new realm.Event('input', {bubbles:true}));
              field.dispatchEvent(new realm.Event('change', {bubbles:true}));
            };
            const hide = name => {
              const field = form.querySelector(`[name="${name}"]`);
              const row = field?.closest('.hs-form-field');
              if (row) row.hidden = true;
            };
            const sourceByRoute = {expo:'nsc-expo-2026',sales:'website-sales',fire:'website-fire',dealer:'website-dealer',support:'website-support'};
            const suppliedSource = params.get('source');
            set('rz_campaign_source', Object.values(sourceByRoute).includes(suppliedSource) ? suppliedSource : sourceByRoute[route]);
            set('rz_inquiry_route', {expo:'Expo sales',sales:'Website sales',fire:'Fire',dealer:'Dealer',support:'Support'}[route]);
            set('rz_questionnaire_purpose', labels[params.get('purpose')]);
            set('rz_questionnaire_air_concern', labels[params.get('air')]);
            set('rz_questionnaire_market', labels[params.get('market')]);
            set('rz_questionnaire_next_step', labels[params.get('need')]);
            const message = form.querySelector('textarea');
            if (topic && message && (!message.value || message.value === autoMessage)) {
              message.value = topic + '\n\n';
              autoMessage = message.value;
              message.dispatchEvent(new Event('input', {bubbles:true}));
              message.dispatchEvent(new Event('change', {bubbles:true}));
            }
            [
              'rz_campaign_source',
              'rz_inquiry_route',
              'rz_questionnaire_purpose',
              'rz_questionnaire_air_concern',
              'rz_questionnaire_market',
              'rz_questionnaire_next_step'
            ].forEach(hide);
            const requestByIntent = {pricing:'Product information',room:'Product information',rzm3:'Product information',sample:'Request a sample',evidence:'Certification and testing documents',ffp2:'Certification and testing documents',ffp3:'Certification and testing documents',workforce:'Team or bulk purchase discussion',enterprise:'Team or bulk purchase discussion',partner:'Dealer or distributor inquiry',guidance:'Talk with the RZ team',n99:'Talk with the RZ team'};
            set('rz_inquiry_type', params.get('intent') === 'partner' ? 'Dealer or distributor inquiry' : route === 'fire' ? 'Fire program inquiry' : requestByIntent[params.get('intent')]);
            const productByIntent = {pricing:'RZ Pro',sample:'RZ Pro',workforce:'RZ Pro',enterprise:'RZ Pro',n99:'RZ Pro',ffp2:'RZ Pro',ffp3:'RZ Pro',rzm3:'RZM3',room:'RZ AIRflow'};
            if (route === 'expo') {
              const requestedProduct = params.get('product_interest') || '';
              const product = requestedProduct === 'RZ Pro 99' ? 'RZ Pro N99' : requestedProduct;
              context.hidden = !product;
              context.textContent = product ? 'Product interest: '+(product === 'RZM3' ? 'RZM3 (uncertified)' : product.replace('RZ Pro N99','RZ Pro 99')) : '';
              productPicker.value = Array.from(productPicker.options).some(o=>o.value===product) ? product : '';
              const nativeProduct = form.querySelector('[name="rz_product_interest"]');
              if(nativeProduct){
                for(const option of nativeProduct.options) if(option.value==='RZ Pro N99') option.text='RZ Pro 99';
                set('rz_product_interest', productPicker.value);
                const productFieldRow = nativeProduct.closest('.hs-form-field');
                if(productFieldRow){productFieldRow.hidden=false;form.prepend(productFieldRow);}
                const order = ['', 'RZ Pro N99', 'RZ Pro FFP2', 'RZ Pro FFP3', 'RZM3', 'Multiple products'];
                Array.from(nativeProduct.options).sort((a,b)=>order.indexOf(a.value)-order.indexOf(b.value)).forEach(option=>nativeProduct.append(option));
                if(!nativeProduct.dataset.rzContextBound){
                  nativeProduct.dataset.rzContextBound='true';
                  nativeProduct.addEventListener('change',()=>{
                    if(params.get('product_interest')===nativeProduct.value)return;
                    params.set('product_interest',nativeProduct.value);
                    productPicker.value=nativeProduct.value;
                    applyContext();
                  });
                }
              }
              const nextN99 = productPicker.value === 'RZ Pro N99';
              if(requestField && nextN99 !== n99Mode){
                if(nextN99) set('rz_inquiry_type','Talk with the RZ team');
                for(const option of requestField.options){
                  const original = requestOptions.find(pair=>pair[1]===option.value);
                  option.text = nextN99 && option.value==='Talk with the RZ team' ? 'Certification status and commercial availability notifications' : original?.[0] || option.text;
                  option.hidden = nextN99 && option.value!=='Talk with the RZ team';
                }
                n99Mode=nextN99;
              }
              if(nextN99){
                set('rz_inquiry_type','Talk with the RZ team');
                heading.textContent='RZ Pro 99 status notifications';
                intro.textContent='Sign up to be notified about certification status and commercial availability. RZ Pro 99 is a product in development and is not yet NIOSH approved. It is not currently offered for sale or use as a certified N99 respirator.';
                if(message && (!message.value || message.value===autoMessage)){message.value='Please notify me about RZ Pro 99 certification status and commercial availability.\n\n';autoMessage=message.value;message.dispatchEvent(new Event('change',{bubbles:true}));}
              }else{heading.textContent=selected.title;intro.textContent=selected.intro;}
            }
            if (route === 'sales') set('rz_product_interest', pageProfile?.product || productByIntent[params.get('intent')] || (params.get('purpose') === 'room' ? 'RZ AIRflow' : ''));
            if (['us','us-required'].includes(params.get('market'))) set('country', 'United States');
            };
            for(const [name,value] of Object.entries(savedContact)) {
              const field = form.querySelector(`[name="${name}"]`);
              if(field && !field.value){field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));}
            }
            applyContext();
            requestField?.addEventListener('change', event => routeCustomerService(form, event));
            form.addEventListener('submit', event => routeCustomerService(form, event), true);
            form.addEventListener('click', event => {
              if (event.target.closest('input[type="submit"],button[type="submit"]')) routeCustomerService(form, event);
            }, true);
            routeCustomerService(form);
          }
        });
      } catch {
        if(current !== revision) return;
        clearTimeout(renderTimer); retry.hidden = false; fallback.hidden = false;
        status.textContent = uiSpanish
          ? 'No se pudo cargar el formulario de ventas. Escribe a steve@rzindustries.com para recibir ayuda. No se ha enviado ninguna consulta.'
          : 'The sales form could not load. Please email steve@rzindustries.com for help. No request has been submitted.';
      }
    }
    retry.addEventListener('click', show);
    picker.addEventListener('change', show);
    form?.addEventListener('submit', event => { if (picker.value !== 'support') event.preventDefault(); });
    const intent = params.get('intent');
    const topic = params.get('topic') || '';
    if (params.get('contact_posted') === 'true' || form?.querySelector('[role="alert"]')) picker.value = 'support';
    else if (inline && ['support','sales','fire','dealer','expo'].includes(inline.dataset.rzInlineRoute)) picker.value = inline.dataset.rzInlineRoute;
    else if (intent === 'support' || params.get('route') === 'support') picker.value = 'support';
    else if (params.get('route') === 'fire' || /fire|rescue/i.test(topic)) picker.value = 'fire';
    else if (intent === 'partner' || params.get('route') === 'dealer') picker.value = 'dealer';
    else if (params.get('source') === 'nsc-expo-2026') picker.value = 'expo';
    else picker.value = 'sales';
    inline?.addEventListener('rz:inquiry-context', event => {
      const next = new URLSearchParams(event.detail);
      if (!next.has('topic')) next.set('topic', next.get('intent') === 'sample' ? 'Complimentary RZ Pro sample request' : pageTopic || 'RZ Pro inquiry');
      for(const key of ['intent','topic','purpose','air','market','need','source','product_interest']) if(next.has(key)) params.set(key,next.get(key));
      const intended = next.get('route') || (next.get('intent') === 'partner' ? 'dealer' : next.get('intent') === 'support' ? 'support' : 'sales');
      const route = inline.dataset.rzInlineRoute === 'expo' && intended !== 'support' ? 'expo' : intended;
      if(picker.value !== route){picker.value=route;show();return;}
      if(!started){show();return;}
      // Keep typed answers intact when a visitor uses another CTA on this page.
      if(applyContext) applyContext();
    });
    // Load on approach, direct form navigation, or an inquiry action; avoid competing with the hero.
    if(inline && location.hash === '#rz-inquiry') show();
    else if(inline && 'IntersectionObserver' in window){
      const observer = new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){if(!started)show();observer.disconnect();}
      },{rootMargin:'600px'});
      observer.observe(inline);
    } else show();
  }
  // Run after the existing form context initializer without changing its bundle.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0), {once:true});
  else setTimeout(init, 0);
})();

